import { SET_ENV, SET_ENV_TOKEN, SET_REFRESH, SET_ISNEW } from './constants';
import { SetEnvAction, SetEnvTokenAction, SetRefreshAction, SetIsNewAction } from './types';

export const setEnv = (payload: SetEnvAction['payload']): SetEnvAction => ({
  type: SET_ENV,
  payload,
})

export const setEnvToken = (payload: SetEnvTokenAction['payload']): SetEnvTokenAction => ({
  type: SET_ENV_TOKEN,
  payload,
})

export const setRefresh = (payload: SetRefreshAction['payload']): SetRefreshAction => ({
  type: SET_REFRESH,
  payload,
})

export const setIsNew = (payload: SetIsNewAction['payload']): SetIsNewAction => ({
  type: SET_ISNEW,
  payload,
})
